import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DocumentsService } from '../../services/common';
import { IconList } from '../../../iconlist';
import { environment } from '../../../environments/environment';
import { DocumentSubType } from '../../../appconfig';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrl: './documents.component.scss'
})

export class DocumentsComponent implements OnInit, OnChanges {
  @Input() docEntityData: any; //doc entity can be anything like user/allotment/booking/ or khasra or uni as document may be related to anything
  @Input() showIsVerified: boolean = false; // to show is verified column or not
  doculemtList: any;
  downloadIcon: string = environment.assetsImagePath + IconList.DownloadIcon
  verifiedIcon: string = environment.assetsImagePath + IconList.VerifiedIcon;
  unVerifiedIcon: string = environment.assetsImagePath + IconList.unVerifiedIcon;

  constructor(private docService: DocumentsService) {
    // Initialize docEntityData if not provided
    if (!this.docEntityData) {
      this.docEntityData = {};
    }
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getEntityDocuments();
  }

  getEntityDocuments() {
    if (this.docEntityData) {
      //Here we are fetching documents based on userId, projectId, documentTypeId, etc. from where ever this component will be called
      //these fields has to be setup based on requirements. as somewhere userId will be there, somewhere projectId will be there, somewhere documentTypeId will be there
      //and somewhere all these fields will be there.
      this.docService.getFilterDocument(this.docEntityData?.userId, this.docEntityData?.allotmentId, this.docEntityData?.bookingId, this.docEntityData?.projectId,
        this.docEntityData?.landKhasraId,
        this.docEntityData?.documentSubTypeId,
        this.docEntityData?.documentTypeId,
        this.docEntityData?.isActive).subscribe(res => {
          if (res) {
            this.doculemtList = res?.result
          }
        })
    }
  }

  downloadFile(currentDocument: any) {
    this.docService.getDocumentBytesById(currentDocument?.documentId).subscribe({
      next: (base64: string) => {
        this.docService.downloadFileFromBase64(base64, currentDocument?.documentFileName || 'downloaded-file');
      },
      error: (err: any) => {
        console.error('Error downloading file', err);
        alert('Download failed');
      }
    });
  }
}
